import api from './api';

export default {
  create: async (applicationId, data) => (await api.post(`/applications/${applicationId}/lease`, data)).data,
  forApplication: async (applicationId) => (await api.get(`/applications/${applicationId}/leases`)).data,
  get: async (id) => (await api.get(`/leases/${id}`)).data,
  mine: async () => (await api.get('/my-leases')).data,
  uploadDocument: async (id, file) => {
    const form = new FormData();
    form.append('file', file);
    return (await api.post(`/leases/${id}/document`, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  downloadDocument: async (id) => (await api.get(`/leases/${id}/document`, { responseType: 'blob' })).data,
  renew: async (id, data) => (await api.post(`/leases/${id}/renew`, data)).data,
  giveNotice: async (id) => (await api.post(`/leases/${id}/notice`)).data,
  terminate: async (id) => (await api.post(`/leases/${id}/terminate`)).data,
};
